import { existingRewardLinkRoutes } from './existing-rl-routes'
import { noExistingRewardLinkRoutes } from './no-existing-rl-routes'
import { printableRewardLinkRoutes } from './printable-rl-routes'
import { walletRoutes } from './wallet-routes'
import { ERROR_ROUTE } from '@/router/routes/route-names'
import ErrorPage from '@/components/ErrorPage'

export const routes = [
  ...existingRewardLinkRoutes,
  ...noExistingRewardLinkRoutes,
  ...walletRoutes,
  {
    path: '/',
    redirect: 'redeem'
  },
  {
    path: '',
    redirect: 'redeem'
  },
  ...printableRewardLinkRoutes,
  {
    path: '/error',
    name: ERROR_ROUTE,
    component: ErrorPage,
    meta: {
      h1: '',
      h2: '',
      h2Hidden: false,
      segmentName: 'Error'
    },
    props: true
  },
  {
    path: '*',
    redirect: 'redeem'
  }
]
